import React, { useMemo } from "react";
import { DeviceControlsContext } from "./context";
import { useDeviceControls } from "../../hooks/deviceControls";
import { DeviceControlsContextState } from "./interfaces";

export type DeviceControlsProviderProps = {
  children: React.ReactNode;
};

export const DeviceControlsProvider: React.FC<DeviceControlsProviderProps> = ({ children }) => {
  const { processAction, applyEntryPresets, applyExitPresets } = useDeviceControls();

  const state = useMemo<DeviceControlsContextState>(() => ({
    processAction,
    applyEntryPresets,
    applyExitPresets,
  }), [processAction, applyEntryPresets, applyExitPresets]);

  return (
    <DeviceControlsContext.Provider value={state}>
      {children}
    </DeviceControlsContext.Provider>
  );
};
